export enum FormType {
  TRAINING = 'training',
  HEALTH_FAIR = 'healthFair'
}

export type FormTypeValue = FormType | null;

